import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/target-inv-simulation", { params });
};

const getPolicy = (params) => {
  return restApiIP.get("/api/target-inv-simulation/policy/", { params });
};

const upsert = data => {
  return restApiIP.post("/api/target-inv-simulation", data);
};

const upsertPolicy = data => {
  return restApiIP.post("/api/target-inv-simulation/policy", data);
};

const remove = ids => {
  return restApiIP.delete(`/api/target-inv-simulation/${ids}`);
};

const run = data => {
  return restApiIP.post("/api/target-inv-simulation/run", data);
};

const bulkValueUpdate = data => {
  return restApiIP.post("/api/target-inv-simulation/bulk-value-update", data);
}


const targetInvSimulationService = {
  getAll,
  getPolicy,
  upsert,
  upsertPolicy,
  remove,
  run,
  bulkValueUpdate
};

export default targetInvSimulationService;